import withInput from './withInput';

const RangeInput = withInput({
  classTypeModifier: 'range-input',
  defaultValue: false,
  forceType: 'range',
});

export default RangeInput;
